/**
 * The theme variables of the neon world Neon Slam and Neon Pack share, and where each falls back
 * to: the same list as `neon_slam` and `neon_pack` in api-contract's `OPENER_KIND_TOKENS` (a test
 * keeps them in step). The glow follows the host's accent; the grid keeps the synthwave cyan and
 * the reflections the violet studio light until a style sets them. There is no sky: the scene is
 * transparent, so the page's own background is its sky.
 */
import type { OpenerTokenFallback } from "../../theme/theme";

export const NEON_TOKENS = {
  glow: { role: "accent" },
  grid: { color: "#37e6ff" },
  env: { color: "#b48cff" },
} as const satisfies Record<string, OpenerTokenFallback>;
